export const STYLE_BLOB_TYPE = 'application/json';
